/**
 * Country Info section ordering — mirrors iOS CountryInfoView.hasTripStarted.
 * Trip start uses device civil YMD vs wall-clock start YMD (#147).
 */

import { hasTripStartedCivil } from './wallClock';

export type CountryInfoSectionId =
  | 'knowBefore'
  | 'health'
  | 'embassy'
  | 'currency'
  | 'tipping'
  | 'rideHail'
  | 'port';

const BEFORE: CountryInfoSectionId[] = [
  'knowBefore',
  'health',
  'embassy',
  'currency',
  'tipping',
  'rideHail',
  'port',
];

const AFTER: CountryInfoSectionId[] = [
  'currency',
  'tipping',
  'rideHail',
  'port',
  'embassy',
  'health',
  'knowBefore',
];

export function hasTripStarted(
  now: Date,
  tripStartDate: string | null | undefined,
  cityArrivalDate: string | null | undefined
): boolean {
  const raw = (tripStartDate || cityArrivalDate || '').trim();
  if (!raw) return false;
  return hasTripStartedCivil(raw, now);
}

export function orderedCountryInfoSections(
  started: boolean,
  options?: { includePort?: boolean }
): CountryInfoSectionId[] {
  const base = started ? AFTER : BEFORE;
  if (options?.includePort === false) {
    return base.filter((id) => id !== 'port');
  }
  return [...base];
}
